module.exports = function(adapterApi) {
  adapterApi().bindToComponent()
  return Promise.all(adapterApi().recordSetLoaded())
}



// WEBPACK FOOTER //
// ./adapters/initAdapters.js